const CTASection = () => {
  const handleClick = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <section className="py-24 bg-gradient-to-br from-[#0052CC] to-[#0066FF]">
      <div className="max-w-[1280px] mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to elevate your organisation?
        </h2>
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          Let's discuss how our services can help you achieve your goals in sport
        </p>
        <button
          onClick={handleClick}
          className="bg-white text-[#0066FF] px-10 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap text-lg"
        >
          Start a Conversation
        </button>
      </div>
    </section>
  );
};

export default CTASection;
